/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Place } from './place.model';
import * as _ from 'lodash';

@Injectable()
export class PlacesService {
  placesSelected: Subject<any> = new Subject<any>();
  placeSelected: Subject<any> = new Subject<any>();
  places: { [key: string]: Place[] } = {};

  selectPlaces(key: any, places: Array<any>) {
    this.places[key] = places;
    this.placesSelected.next({
      key,
      places,
    });
  }

  selectPlace(key: any, place: any) {
    this.places[key] = [..._.unionBy(this.places[key], [place], 'uuid')];
    this.placeSelected.next({
      key,
      place,
    });
  }
}
